import {
  Button,
  ExperimentalOutlinedCard,
  ExperimentalOutlinedCardAvatar,
  Stacked,
  Typography,
} from '@statsbomb/kitbag-components';
import { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

type QuickStartCardProps = {
  avatar?: ReactElement;
  title?: string;
  description: ReactNode;
  // An in-app route, or `href` for a page outside the New Experience
  to?: string;
  href?: string;
};

// Avatar and title on the left, View on the right, and one line of context underneath.
export const QuickStartCard = ({ avatar, title, description, to, href }: QuickStartCardProps) => {
  const { t } = useTranslation('home');
  const viewLabel = t('quickStart.viewLabel', { title });
  const viewButton = (
    <Button as="span" size="small" variant="secondary">
      {t('quickStart.view')}
    </Button>
  );

  return (
    <ExperimentalOutlinedCard>
      {title && (to || href) && (
        <Stacked justifyContent="space-between">
          <Stacked gap="tiny">
            {avatar && <ExperimentalOutlinedCardAvatar>{avatar}</ExperimentalOutlinedCardAvatar>}
            <Typography as="h3" variant="headingMedium">
              {title}
            </Typography>
          </Stacked>
          {to ? (
            <Link to={to} aria-label={viewLabel}>
              {viewButton}
            </Link>
          ) : (
            <a href={href} aria-label={viewLabel}>
              {viewButton}
            </a>
          )}
        </Stacked>
      )}
      <Typography variant="bodySmall" muted>
        {description}
      </Typography>
    </ExperimentalOutlinedCard>
  );
};
